import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailComponent } from './email.component';
import { FrameworkModule } from '@app/framework/framework.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  declarations: [EmailComponent],
  exports: [EmailComponent],
  imports: [SharedModule, FrameworkModule, CommonModule, FormsModule],
})
export class EmailModule {}
